import { apiRequest } from "./index";

export const createYearlyIndicatorsRequest = (brokers) => {
  return apiRequest(
    `/admin/yearly-indicators`,
    {
      method: "POST",
      body: JSON.stringify(brokers),
    },
    true
  );
};
export const getYearlyIndicatorsRequest = (filters) => {
  const { page = 0, limit = 0, search = "" } = filters;

  return apiRequest(
    `/admin/yearly-indicators?page=${page}&limit=${limit}&search=${search}`,
    {
      method: "GET",
    },
    true
  );
};

export const getYearlyIndicatorRequest = (id) => {
  return apiRequest(
    `/admin/yearly-indicators/${id}`,
    {
      method: "GET",
    },
    true
  );
};

export const updateYearlyIndicatorRequest = (brokers) => {
  return apiRequest(
    `/admin/yearly-indicators/${brokers._id}`,
    {
      method: "PUT",
      body: JSON.stringify(brokers),
    },
    true
  );
};

export const deleteYearlyIndicatorRequest = (id) => {
  return apiRequest(
    `/admin/yearly-indicators/${id}`,
    {
      method: "DELETE",
    },
    true
  );
};
